<template>
  <BaseListItem v-if="edit">
    <div class="flex items-baseline -mx-4">
      <div class="flex flex-1 px-2">
        <ValidationProvider
          name="address"
          :vid="`emails.${index}.address`"
          rules="required|email"
          v-slot="{ errors, failed }"
          slim
        >
          <BaseFormGroup class="w-full">
            <BaseFormInput
              v-model.lazy="address"
              :disabled="updating"
              :invalid="failed"
              placeholder="email address"
            />
            <BaseFormInlineMessage v-if="failed" danger>
              {{ errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </ValidationProvider>
      </div>
      <div class="pr-2">
        <BaseIconButton v-if="!updating" icon="trash" brand @click="$emit('destroy')" />
        <Loader v-else small />
      </div>
    </div>
  </BaseListItem>
  <BaseListItem v-else-if="updating">
    <div class="flex items-baseline -mx-4">
      <div class="flex-1 px-4 text-red-500 text-center">
        <Loader medium />
      </div>
    </div>
  </BaseListItem>
  <BaseListItem v-else>
    <div class="flex items-baseline -mx-4">
      <div class="flex-1 px-4 truncate">
        {{ entity.address }}
      </div>
    </div>
  </BaseListItem>
</template>

<script>
export default {
  name: 'ListingItem',
  props: {
    index: {
      type: Number,
      required: true,
    },
    entity: {
      type: Object,
      required: true,
    },
    edit: Boolean,
    updating: Boolean,
  },
  computed: {
    address: {
      get() {
        return this.entity.address;
      },
      set(address) {
        this.$emit('change', { ...this.entity, address });
      },
    },
  },
};
</script>
